import { ComponentProps, FC, useContext } from 'react'
import { Text } from '../../Text'
import { EditorContext } from '../EditorContext'

export const EditorError: FC<ComponentProps<typeof Text>> = (props) => {
  const { editorError } = useContext(EditorContext)

  if (!editorError) {
    return null
  }

  return (
    <Text size="12" {...props}>
      {editorError}
    </Text>
  )
}
